import React from "react";
import "./CarLoader.scss";

const CarLoader = ({heading, text}) => {
  return (
    <div className="carMainFlx">
      <div className="carAnimBg">
      <div className="carbg">
        {heading && <h3 className="carHdFetchTxt">{heading}</h3>}
       <div className="carDataFetchTxt">{text}</div>
       </div>
      </div>      
    </div>
  );
};

export default CarLoader;
